// extracted by mini-css-extract-plugin
export default {"center":"About_center__ZPJ1A","aspectRatio":"About_aspectRatio__C1MgA","profileImage":"About_profileImage__c4pTg","text":"About_text__qkxfr"};